import { contactInfo } from "@/mocks/homeData";

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-950">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-background-50 mb-4 font-heading tracking-wide">
          Un besoin d'entretien ou une panne à faire diagnostiquer ?
        </h2>
        <p className="text-background-300 text-base md:text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
          Contactez Mobicar Pro pour présenter votre besoin et demander un
          devis de réparation automobile au Tampon. L'équipe vous répond avec
          sérieux et clarté.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href={contactInfo.phoneHref}
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-md transition-colors whitespace-nowrap w-full sm:w-auto justify-center"
          >
            <i className="ri-phone-line w-5 h-5 flex items-center justify-center" />
            Appeler le {contactInfo.phone}
          </a>
          <a
            href={contactInfo.whatsappDevisHref}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-semibold rounded-md border border-background-300 transition-colors whitespace-nowrap w-full sm:w-auto justify-center"
          >
            <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center" />
            Demander un devis
          </a>
        </div>
      </div>
    </section>
  );
}